export default function(slug, callback){
    fetch("https://ideasmulticolor.com/wp-json/wp/v2/pages/?slug="+slug).then((data)=>{return data.json()}).then((data)=>{
        callback(data[0]);
     });
  }
 